const needSessionRequest = [
  '/api/getLineUrl',
  '/api/getWechatUrl',
  '/api/v1/getMiniProgramtUrl',
  '/api/v1/landingPage/getActivityConfig',
  '/api/v1/coupon/sendCouponById',
  '/api/v1/landingPage/getWheelPrizeInfo',
  '/api/v1/landingPage/invokeActivity',
  '/api/v1/landingPage/frequencyCheck',
]

export default needSessionRequest;
